import React, { useState, useEffect, useContext, useRef } from "react";
import { useTable, useRowSelect } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../multiSelect/MultiSelect";
import { columnBaseTable } from "./column";
import swal from "sweetalert";
import "./basicTable.css";
import { Spinner } from "react-bootstrap";
import { ThemeContext } from "../../helper/DarkModeContext";
import { fetchConventionalMode, updateConventionalMode } from "../../redux/actions/TemplateTabs/actionCM";
import { storeDragSelected, storeDragMultiSelected } from "../../redux/actions/TemplateTabs/actionDragSelector";
import { fetchColumns } from "../../redux/actions/TemplateTabs/actionNewColumns";
import { fetchTTGroupData } from "../../redux/actions/TemplateTabs/actionGrouping";
import { motion } from "framer-motion";
import { getMappingDetails } from "../../WorkSpace/Components/ApiServices/apiHandler";
import commoncss from "../../myfin_v2/css/common.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import dropdowncss from "../../myfin_v2/css/dropdown.module.css";
import Pagination from "../../myfin_v2/components/receivableselements/Pagination";

const BasicTable = (props) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const { hideItems, filterEnable } = props;
  const dispatch = useDispatch();
  const R_tb_id = useSelector((initialState) => initialState.reducer.tb_id);
  const LOCAL_tb_id = localStorage.getItem("tb_id");
  let tb_id = R_tb_id ? R_tb_id : LOCAL_tb_id;

  const conventionModeData = useSelector((state) => state.ConventionModeReducer);

  const [currentPage, setCurrentPage] = useState(conventionModeData?.pagination?.page || 1);
  const [rowsPerPage, setRowsPerPage] = useState(conventionModeData?.pagination?.limit || 100);
  const rowRefs = useRef({});
  const { nctLoading, nct_error_message, nctIsSuccess, newColumns } = useSelector((state) => state.NCTable);

  const [conventionalData, setConventionalData] = useState([]);
  const groupData = useSelector((state) => state.TTGroupingReducer);
  const { checkYearly } = useSelector((state) => state.selectedDragReducer);
  const groupDataRes = groupData.response ?? [];
  
  props.setTotalRow(conventionalData);
  
  const [selected, setSelected] = useState("");
  const [highlight, setHighlight] = useState(false);
  const { theme } = useContext(ThemeContext);

  const [columnHeader, setColumnHeader] = useState([]);

  const project_id = localStorage.getItem("project_id");
  const handlePageChange = (newPage) => {
    dispatch(fetchConventionalMode(project_id, tb_id, newPage, rowsPerPage, conventionModeData?.activeFilters, hideItems ? 'ungrouped' : undefined));
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    dispatch(fetchConventionalMode(project_id, tb_id, 1, newRowsPerPage, conventionModeData?.activeFilters, hideItems ? 'ungrouped' : undefined));
  };
  useEffect(() => {
    if (conventionModeData.pagination) {
      setCurrentPage(conventionModeData.pagination.page);
      setRowsPerPage(conventionModeData.pagination.limit);
    }
  }, [conventionModeData.pagination?.page, conventionModeData.pagination?.limit]);
  const [comparativeYearData, setComparativeYearData] = useState({});

  useEffect(() => {
    fetchComparativeYear();
  }, []);

  const fetchComparativeYear = async () => {
    try {
      const projectID = localStorage.getItem("project_id");
      const res = await getMappingDetails(projectID);
      if (res?.data?.success) {
        setComparativeYearData(res.data); 
      }
    } catch (err) {
      console.log("Comparative year fetch error:", err);
    }
  };
 
useEffect(() => {
  if (props.onRowRefsReady) {
    props.onRowRefsReady(rowRefs); 
  }
}, []);

  useEffect(() => {
    getNewColumnUpdate();
  }, [nctIsSuccess, newColumns]);




  useEffect(() => {
    if (conventionModeData.isSuccess) {
      setConventionalData(conventionModeData.response?.data?.line_items || []);
    }
  }, [conventionModeData.response])

  useEffect(() => {
     console.log(
        "LINE ITEMS =>",
        conventionModeData.response?.data?.line_items?.[0]
      );

    if (filterEnable) {
      setConventionalData(conventionModeData.filteredData ?? [])
    } else {
      setConventionalData(
        conventionModeData.response?.data?.line_items || []
      );
    }
  }, [filterEnable, conventionModeData.filteredData])

  useEffect(() => {
    (async () => {
      await fetchGroupData();
      await getNewColumnUpdate();
    })();
  }, [checkYearly]);

  useEffect(() => {
    // if (!nctIsSuccess) {
    dispatch(fetchColumns(project_id))
    // }
  }, [])

  const fetchGroupData = async () => {
    const target_tb_id = LOCAL_tb_id || tb_id;
    if (
      !groupData.isSuccess ||
      groupData.set_payload !== JSON.stringify({ project_id, tb_id: target_tb_id })
    ) {
      dispatch(fetchTTGroupData(project_id, target_tb_id));
    }
  };

  const mergeInPlace = (a, b, i = 0) => {
    return a.slice(0, i).concat(b, a.slice(i));
  };

  // const getNewColumnUpdate = async () => {
  //   try {
  //     let a = [...columnBaseTable];
  //     let b = [];
  //     let merge = mergeInPlace(a, b, 3);
  //     if (nctIsSuccess) {
  //       if (newColumns) {
  //         let updatedColumns = [...merge];
  //         updatedColumns.splice(2, 0, ...newColumns);
  //         setColumnHeader(updatedColumns);
  //       } else {
  //         setColumnHeader(merge);
  //       }
  //     } else { setColumnHeader(merge); }
  //   } catch (err) {
  //     console.error("error", err.message);
  //   }
  // };
  const getNewColumnUpdate = async () => {
  try {
    let a = [...columnBaseTable];
    let b = [];
    let merge = mergeInPlace(a, b, 3);

    const comparativeYearColumn = {
      Header: "COMPARATIVE YEAR",
      accessor: "comparative_year",
      Style: { minWidth: "150px" },
    };

    const insertAfterPY = (columns) => {
      const pyIndex = columns.findIndex(col => col.Header === "PREVIOUS YEAR");
      const result = [...columns];
      if (pyIndex !== -1) {
        result.splice(pyIndex + 1, 0, comparativeYearColumn);
      } else {
        result.push(comparativeYearColumn);
      }
      return result;
    };

    if (nctIsSuccess) {
      if (newColumns) {
        let updatedColumns = [...merge];
        updatedColumns.splice(2, 0, ...newColumns);
        setColumnHeader(insertAfterPY(updatedColumns));
      } else {
        setColumnHeader(insertAfterPY(merge));
      }
    } else {
      setColumnHeader(insertAfterPY(merge));
    }
  } catch (err) {
    console.error("error", err.message);
  }
};
  function brackets(val) {
    if (val < 0) {
      return "(" + (-1 * val).toLocaleString("en-IN") + ")";
    }
    return val.toLocaleString("en-IN");
  }

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );

  let total = 0;
  let finaldata = 0;
  const lenghtdata = conventionalData.length;
  const selectedRows = (data) => {
    total = total + 1;
    finaldata = (total / lenghtdata) * 100;
    props.getdata(Math.round(finaldata));
    // dispatch({ type: actionTypes.SET_PROGRESSBAR_DATA, payload: finaldata });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns: columnHeader,
      data: conventionalData,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  useEffect(() => {
    dispatch(storeDragMultiSelected(selectedFlatRows.map(row => row.original)))
  }, [selectedFlatRows])

  const handleMap = async (type, row, change, type2) => {
    if (!change) return;
     const cyRate = comparativeYearData?.translateFS?.currentYearAverageRate;
     const comparativeVal = cyRate && row.cy ? Number(row.cy) * Number(cyRate) : row.cy;
    switch (type) {
      case "fs_grp": {
        const mapData = {
          fs_grp: change,
          note_grp: "",
          sub_grp: "",
          note_no: ""
        }
        let updatedData = {
          ...row,
          comparative: comparativeVal,
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }
        const currentYearMap = updatedData.map_data?.cy_map || {
          fs_grp: updatedData.fs_grp || "",
          note_grp: updatedData.note_grp || "",
          note_no: updatedData.note_no || "",
          sub_grp: updatedData.sub_grp || ""
        };
        updatedData.fs_grp = currentYearMap.fs_grp;
        updatedData.note_grp = currentYearMap.note_grp;
        updatedData.note_no = currentYearMap.note_no;
        updatedData.sub_grp = currentYearMap.sub_grp;

        const element = conventionalData.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
          element.fs_grp = updatedData.fs_grp;
          element.note_grp = updatedData.note_grp;
          element.note_no = updatedData.note_no;
          element.sub_grp = updatedData.sub_grp;
        }
        setConventionalData([...conventionalData]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      case "note_grp": {
        let parseChange = JSON.parse(change);
        let currentFsGrp = row?.map_data?.[type2 + '_map']?.fs_grp || row.fs_grp;
        let newSubGrp = "";

        // Auto-select sub_grp if there is exactly 1 option available
        const matchedFs = groupDataRes?.fs_grp?.find(f => f.fs_grp === currentFsGrp);
        if (matchedFs) {
          const matchedNote = matchedFs.notes_grp?.find(n => n.notes_grp === parseChange.notes_grp);
          if (matchedNote && matchedNote.sub_grp && matchedNote.sub_grp.length === 1) {
            newSubGrp = matchedNote.sub_grp[0].sub_grp;
          }
        }

        const mapData = {
          fs_grp: currentFsGrp,
          note_grp: parseChange.notes_grp,
          note_no: parseChange.notes_no,
          sub_grp: newSubGrp,
        }
        let updatedData = {
          ...row,
           comparative: comparativeVal,
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }

        const currentYearMap = updatedData.map_data?.cy_map || {
          fs_grp: updatedData.fs_grp || "",
          note_grp: updatedData.note_grp || "",
          note_no: updatedData.note_no || "",
          sub_grp: updatedData.sub_grp || ""
        };
        updatedData.fs_grp = currentYearMap.fs_grp;
        updatedData.note_grp = currentYearMap.note_grp;
        updatedData.note_no = currentYearMap.note_no;
        updatedData.sub_grp = currentYearMap.sub_grp;

        // update data in table locally immediately
        const element = conventionalData.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
          element.fs_grp = updatedData.fs_grp;
          element.note_grp = updatedData.note_grp;
          element.note_no = updatedData.note_no;
          element.sub_grp = updatedData.sub_grp;
        }
        setConventionalData([...conventionalData]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      case "sub_grp": {
        const mapData = {
          fs_grp: row?.map_data?.[type2 + '_map']?.fs_grp || row.fs_grp,
          note_grp: row?.map_data?.[type2 + '_map']?.note_grp || row.note_grp,
          note_no: row?.map_data?.[type2 + '_map']?.note_no || row.note_no,
          sub_grp: change
        }
        let updatedData = {
          ...row,
          comparative: comparativeVal,
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }

        const currentYearMap = updatedData.map_data?.cy_map || {
          fs_grp: updatedData.fs_grp || "",
          note_grp: updatedData.note_grp || "",
          note_no: updatedData.note_no || "",
          sub_grp: updatedData.sub_grp || ""
        };
        updatedData.fs_grp = currentYearMap.fs_grp;
        updatedData.note_grp = currentYearMap.note_grp;
        updatedData.note_no = currentYearMap.note_no;
        updatedData.sub_grp = currentYearMap.sub_grp;

        // update data in table locally immediately
        const element = conventionalData.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
          element.fs_grp = updatedData.fs_grp;
          element.note_grp = updatedData.note_grp;
          element.note_no = updatedData.note_no;
          element.sub_grp = updatedData.sub_grp;
        }
        setConventionalData([...conventionalData]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      default:
        return false
    }
  }

  // UPDATED handleDrag: accepts the native drag event and populates dataTransfer + fallback
  const handleDrag = (e, cell) => {
    // if no permission to drag
    if (user.responsibilities === "view" || user.responsibilities === "approver") {
      swal("Warning", "You don't have access to drag and drop", "warning");
      e.preventDefault?.();
      return false;
    }

    // prepare payload: if multi-selected rows exist, send array; else send single
    const selectedPayload = selectedFlatRows && selectedFlatRows.length > 0
      ? selectedFlatRows.map(r => r.original)
      : [cell.row.original];

    let draggedColumn = "cy";
    if (cell?.column?.Header === "PREVIOUS YEAR" || cell?.column?.Header === "COMPARATIVE YEAR") {
      draggedColumn = "py";
    }

    const payload = {
      type: "conventionalRow",
      draggedColumn,
      items: selectedPayload.map(item => ({
        id: item.lid ?? item._id ?? item.id,
        ledger_code: item.ledger_code,
        ledger_name: item.ledger_name ?? item.name,
        cy: Number(item.cy || 0) + Number(item.adjusted_amount || 0),
        py: Number(item.py || 0),
        map_data: item.map_data ?? null,
        item_: item
      })),
      meta: {
        timestamp: Date.now(),
        project_id,
      },
    };

    // UI state & redux store
    setHighlight(false);
    if (!selectedFlatRows || selectedFlatRows.length === 0) {
      setSelected(cell.row.original.lid);
      dispatch(storeDragSelected(cell.row.original));
    } else {
      // multi selected - ensure store updated
      dispatch(storeDragSelected(selectedPayload));
    }

    // put payload into native dataTransfer; fall back to global variable if setData fails
    try {
      e.dataTransfer.setData("application/json", JSON.stringify(payload));
      e.dataTransfer.setData("text/plain", JSON.stringify(payload));
      e.dataTransfer.effectAllowed = "copyMove";
    } catch (err) {
      console.warn("dataTransfer.setData failed, using global fallback", err);
      // global fallback only works in same window
      window.__MY_APP_DRAG_PAYLOAD = payload;
      try { e.dataTransfer.setData("text/plain", "app-drag"); } catch {}
    }
  }

  const handleGroupData = (type, row, mapType) => {
    
    let { fs_grp, note_grp } = row.original;
    if (row.original.hasOwnProperty('map_data') && row.original.map_data.hasOwnProperty(mapType) && row.original.map_data[mapType]) {
      fs_grp = row.original.map_data[mapType].fs_grp;
      note_grp = row.original.map_data[mapType].note_grp;
    }
    const groupDataRes = groupData.response ?? [];
    switch (type) {
      case "fs_grp_cy":
        if (groupData.isSuccess) {
          return groupDataRes?.fs_grp?.map(fsGrp => fsGrp.fs_grp)
        } else {
          return []
        }
      case "fs_grp_py":
        if (groupData.isSuccess) {
          return groupDataRes?.fs_grp?.map(fsGrp => fsGrp.fs_grp)
        } else {
          return []
        }
      case "note_grp_cy":
        if (groupData.isSuccess && fs_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.map(notes => { return { notes_grp: notes.notes_grp, notes_no: notes.notes_no } })
        } else {
          return []
        }
      case "note_grp_py":
        if (groupData.isSuccess && fs_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.map(notes => { return { notes_grp: notes.notes_grp, notes_no: notes.notes_no } })
        } else {
          return []
        }
      case "sub_grp_cy":
        if (groupData.isSuccess && fs_grp && note_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.find(note => note.notes_grp === note_grp)?.sub_grp.map(subGrp => subGrp.sub_grp)
        } else {
          return []
        }
      case "sub_grp_py":
        if (groupData.isSuccess && fs_grp && note_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.find(note => note.notes_grp === note_grp)?.sub_grp.map(subGrp => subGrp.sub_grp)
        } else {
          return []
        }
      default:
        return []
    }
  }

  if (conventionModeData.loading || groupData.loading) {
    return (
      <div
        style={{
          height: "80vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner animation="grow" size="sm" />
        <Spinner animation="grow" style={{ margin: "1rem" }} />
        <Spinner animation="grow" size="sm" />
      </div>
    );
  }
  const getAlignClass = (header) => {
    switch (header) {
      case "LEDGER CODE":
        return "text-left";
      case "LEDGER NAME":
        return "text-left";
      case "BRANCH":
        return "text-center";
      case "CURRENT YEAR":
        return "text-right";
      case "CURRENT YEAR":
        return "text-right";
      case "FINAL AMT":
        return "text-right";
      case "ADJUSTMENT AMT":
        return "text-right";
      case "PREVIOUS YEAR":
        return "text-right";
      case "COMPARATIVE YEAR":
        return "text-right";
      default:
        return "text-center";
    }
  };

  const getDisplayHeader = (header) => {
    return header === "ADJUSTMENT AMT" ? "ADJ AMOUNT" : header;
  };

  return (
    <motion.div
      initial={{ x: 100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 0, opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1, 
        overflow: 'hidden', 
        width: '100%',
        placeSelf: 'flex-start'
      }}
      className={!props.isTempMode ? tablecss.stdTableContainer : ""}
    >
      <MultiSelect
        setAddGrouping={props.setAddGrouping}
        SetNewSg={props.SetNewSg}
        multiOptions={props.multiOptions}
        fetchConvential={props.fetchConvential}
      />
      <div className="hide-scrollbar"
      style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
      <table
        className={`${tablecss.customTable} ${tablecss.stickyTable} basicTableOverride`}
        style={{ borderCollapse: "separate", borderSpacing: 0 }}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th className={`font-inter ${getAlignClass(column.render("Header"))}`}
                  style={column.Style}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header") === "ADJUSTMENT AMT" ? "ADJ AMOUNT" : column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, ind) => {
            if (row.original.sub_grp !== "") {
              selectedRows(row.original.sub_grp);
            }
            prepareRow(row);
            return (
              <tr
             ref={el => {
                if (el && row.original?.ledger_name) {
                  rowRefs.current[row.original.ledger_name] = el;
                
                  const noteGrp = row.original?.map_data?.cy_map?.note_grp
                    || row.original?.map_data?.py_map?.note_grp
                    || row.original?.note_grp;
                  if (noteGrp) console.log("note_grp:", noteGrp, "| ledger:", row.original.ledger_name);
                }
              }}
                onClick={() => prepareRow(row)}
                className={
                  row.isSelected
                    ? "highlightedRow"
                    : (row.original?.map_data?.cy_map && row.original?.map_data?.py_map || row.original)?.sub_grp
                      ? "selectedRow"
                      : (row.original?.map_data?.cy_map || row.original?.map_data?.py_map)?.sub_grp
                        ? "selectedSingleRow"
                        : null
                }
                {...row.getRowProps()}
              >
                {row.cells.map((cell, i) => {
                  if (cell.column.Header === "LEDGER CODE") {
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        {...cell.getCellProps()}
                        style={{ textAlign: "left", paddingLeft: "15px", minWidth: "130px" }}
                      >
                        {cell.row.original.ledger_code}
                      </td>
                    );
                  }
                  if (cell.column.Header === "LEDGER NAME") {
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        {...cell.getCellProps()}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        style={{
                          textAlign: "left",
                          paddingLeft: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  }
                  if (cell.column.Header === "BRANCH") {
                    if (cell.row.original.branch == null) {
                      return (
                        <td
                          draggable="true"
                          onDragStart={(e) => {
                            handleDrag(e, cell);
                          }}
                          onDragEnd={() => {
                            setHighlight(false);
                            if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                          }}
                          className={
                            highlight && cell.row.original.lid === selected
                              ? "highlighted"
                              : null
                          }
                          style={{ textAlign: "center" }}
                        >
                          -
                        </td>
                      );
                    }
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        {...cell.getCellProps()}
                        style={{ textAlign: "center" }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  }
                  if (cell.column.Header === "ADJUSTMENT AMT") {
                    if (cell.row.original.adjusted_amount === 0) {
                      return (
                        <td
                          draggable="true"
                          onDragStart={(e) => {
                            handleDrag(e, cell);
                          }}
                          onDragEnd={() => {
                            setHighlight(false);
                            if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                          }}
                          className={
                            highlight && cell.row.original.lid === selected
                              ? "highlighted"
                              : null
                          }
                          style={{ textAlign: "right", padding: "10px" }}
                        >
                          -
                        </td>
                      );
                    }
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        style={{ textAlign: "right", padding: "10px" }}
                      >
                        {Math.round(cell.row.original.adjusted_amount)}
                      </td>
                    );
                  }
                  if (cell.column.Header === "FINAL AMT") {
                    if (cell.row.original.isAdjusted) {
                      return (
                        <td
                          draggable="true"
                          onDragStart={(e) => {
                            handleDrag(e, cell);
                          }}
                          onDragEnd={() => {
                            setHighlight(false);
                            if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                          }}
                          className={
                            highlight && cell.row.original.lid === selected
                              ? "highlighted"
                              : null
                          }
                          style={{ textAlign: "right", padding: "10px" }}
                        >
                          {brackets(
                            Math.round(Number(cell.row.original.cy) +
                            Number(cell.row.original.adjusted_amount))
                          )}
                        </td>
                      );
                    }
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        style={{ textAlign: "right", padding: "10px" }}
                      >
                        <div
                          title={`${brackets(
                            Math.round(Number(cell.row.original.cy) +
                            Number(cell.row.original.adjusted_amount))
                          )}`}
                          className="visible"
                        >
                          {brackets(
                            Math.round(Number(cell.row.original.cy) +
                            Number(cell.row.original.adjusted_amount))
                          )}
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "CURRENT YEAR") {
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        {...cell.getCellProps()}
                        style={{ textAlign: "right", paddingRight: "10px" }}
                      >
                        {cell.row.original.cy
                          ? brackets(Math.round(Number(cell.row.original.cy)))
                          : 0}
                      </td>
                    );
                  }
                  if (cell.column.Header === "PREVIOUS YEAR") {
                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => {
                          handleDrag(e, cell);
                        }}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected
                            ? "highlighted"
                            : null
                        }
                        {...cell.getCellProps()}
                        style={{ textAlign: "right", paddingRight: "10px" }}
                      >
                        {cell.row.original.py
                          ? brackets(Math.round(Number(cell.row.original.py)))
                          : 0}
                      </td>
                    );
                  }
                  if (cell.column.Header === "COMPARATIVE YEAR") {
                    const cyRate = comparativeYearData?.translateFS?.currentYearAverageRate;
                    const pyVal = cell.row.original.py;
                    let comparativeVal = "-";
                    if (cyRate && pyVal) {
                      const rawVal = Number(pyVal) * Number(cyRate);
                      comparativeVal = brackets(Math.round(rawVal));
                    }

                    return (
                      <td
                        draggable="true"
                        onDragStart={(e) => handleDrag(e, cell)}
                        onDragEnd={() => {
                          setHighlight(false);
                          if (window.__MY_APP_DRAG_PAYLOAD) delete window.__MY_APP_DRAG_PAYLOAD;
                        }}
                        className={
                          highlight && cell.row.original.lid === selected ? "highlighted" : null
                        }
                        {...cell.getCellProps()}
                        style={{ textAlign: "right", paddingRight: "10px" }}
                      >
                        {comparativeVal}
                      </td>
                    );
                  }
                  if (cell.column.Header === "FS GROUPING (CY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"fs_grp"}
                            options={handleGroupData("fs_grp_cy", row, "cy_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"cy"}
                          />
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "NOTES GROUPING (CY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"note_grp"}
                            options={handleGroupData("note_grp_cy", row, "cy_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"cy"}
                          />
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "SUB GROUPING (CY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"sub_grp"}
                            options={handleGroupData("sub_grp_cy", row, "cy_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"cy"}
                          />
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "FS GROUPING (PY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"fs_grp"}
                            options={handleGroupData("fs_grp_py", row, "py_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"py"}
                          />
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "NOTES GROUPING (PY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"note_grp"}
                            options={handleGroupData("note_grp_py", row, "py_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"py"}
                          />
                        </div>
                      </td>
                    );
                  }
                  if (cell.column.Header === "SUB GROUPING (PY)") {
                    return (
                      <td
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="dropMapping"
                      >
                        <div className="visible">
                          <SelectComponent
                            rowData={row}
                            type={"sub_grp"}
                            options={handleGroupData("sub_grp_py", row, "py_map")}
                            handleChange={handleMap}
                            checkYearly={checkYearly}
                            type2={"py"}
                          />
                        </div>
                      </td>
                    );
                  }
                  return (
                    <td
                      {...cell.getCellProps()}
                      style={
                        cell.column.id === "selection"
                          ? { textAlign: "center", padding: "0px" }
                          : { textAlign: "right", paddingRight: "10px" }
                      }
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      <div style={{ borderTop: "1px solid #eaeeed", paddingTop: "5px" }}>
        <Pagination
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPages={conventionModeData.pagination?.totalPages || 0}
            totalRecords={conventionModeData.pagination?.total || 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
    </motion.div>
  );
};

export default BasicTable;

export const SelectComponent = (props) => {
  const { rowData, type, options, handleChange, checkYearly, type2, disabled } = props;
  const [value, setValue] = useState(null);

  useEffect(() => {
    const currentVal = getGroupName(rowData.original, type);
    // console.log("CURRENT VALUE =>", currentVal);
    // console.log("ROW DATA =>", rowData.original);
    // console.log("MAP DATA =>", rowData.original.map_data);
    if (type === 'note_grp') {
      // Find the matched option to ensure exact stringification
      const matchedOpt = options?.find(o => o.notes_grp === currentVal);
      if (matchedOpt) {
        setValue(JSON.stringify(matchedOpt));
      } else {
        const noteNo = getGroupName(rowData.original, 'note_no');
        setValue(JSON.stringify({ notes_grp: currentVal, notes_no: noteNo }));
      }
    } else {
      setValue(currentVal);
    }
  }, [rowData, type, type2, options]);

  const getGroupName = (rowData, type) => {
    const checkMap = type2 + '_map';
    if (rowData.hasOwnProperty("map_data") && rowData.map_data.hasOwnProperty(checkMap) && rowData.map_data[checkMap]) {
      return rowData.map_data[checkMap][type];
    } else {
      return rowData[type];
    }
  };

  const formattedOptions = options?.map((opt) => {
    if (type === 'note_grp') {
      return {
        label: opt.notes_grp,
        value: JSON.stringify(opt),
      };
    }
    return {
      label: opt,
      value: opt,
    };
  }) || [];
  return (
    <div className="dropMapping" style={{ ...(disabled ? { pointerEvents: 'none', opacity: 0.6 } : {}), maxWidth: '220px' }}>
      <Dropdown
        key={`${type}-${value}`}
        class_={dropdowncss.previewDropdown}
        style2={{ backgroundColor: '#ffffff', borderRadius: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        options={formattedOptions}
        selValue={value}
        disableAutoSelect={true}
        onSelect={(opt) => {
          if (opt) {
            setValue(opt.value);
            handleChange(type, rowData.original, opt.value, type2);
          }
        }}
        placeHolder="Select an option..."
      />
    </div>
  );
};
